import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {BinLineModel} from '../../../../../../models/aggregates/erp/stock';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class BinLineService extends BaseApiTemplateService<BinLineModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'bin-line';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'bin-line';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'bin-line';
    this.httpClient = http;
  }

}


